export const accordionSx = {
  backgroundColor: "transparent",
  border: "1px solid var(--border)",
  borderRadius: "12px",
  boxShadow: "none",
  color: "var(--text)",
  "& .MuiAccordionSummary-root": {
    color: "var(--text)"
  },
  "& .MuiAccordionDetails-root": {
    color: "var(--text)"
  },
  "&::before": { display: "none" },
  "& + &": { marginTop: "12px" }
};

export const accordionSummarySx = {
  padding: "0 16px",
  minHeight: "60px",
  color: "var(--text)",
  "& .MuiAccordionSummary-content": {
    margin: 0,
    alignItems: "center",
    flexDirection: "row",
    gap: "8px"
  },
  "& .MuiAccordionSummary-expandIconWrapper": {
    color: "var(--text-dim)"
  }
};

export const accordionTitleStyle = {
  fontSize: "20px",
  fontWeight: 700,
  color: "var(--text-dim)"
};

export const accordionDetailsSx = {
  padding: "16px",
  backgroundColor: "transparent",
  borderTop: "1px solid var(--border)",
  color: "var(--text)"
};
